var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.timeLeft)?_c('span',[(_vm.timeLeft.minus)?_c('span',[_vm._v("-")]):_vm._e(),_vm._v(" "+_vm._s(_vm.timeLeft.hours)+" : "+_vm._s(_vm.timeLeft.minutes)+" : "+_vm._s(_vm.timeLeft.seconds)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }